import { GET_CHOOSE_TYPE, GET_ROLES, GET_SEND_OTP, GET_VERIFY_OTP } from "../ConstAction";

export const sendotp = (data, setComponent, setLoading) => {
  return {
    type: GET_SEND_OTP,
    data: data,
    setComponent: setComponent,
    setLoading: setLoading,
  };
};

export const verifyotp = (data, orders, setComponent, setLoading, navigate) => {
  
  return {
    type: GET_VERIFY_OTP,
    data: data,
    setComponent: setComponent,
    setLoading: setLoading,
    navigate: navigate,
    orders: orders,
  };
};
export const roles = () => {
  return {
    type: GET_ROLES,
  };
};

export const choosetype = (data, setLoading, navigate,orders) => {
  return {
    type: GET_CHOOSE_TYPE,
    data: data,
    setLoading: setLoading,
    navigate: navigate,
    orders: orders,
  };
};
